import { useEffect } from "react";
const SITE_URL = "https://tbcareer.com";

const usePageSEO = ({
  title,
  description,
  keywords = [],
  ogTitle,
  ogDescription,
  ogSite_name = "TB Career",
  ogImage,
  ogUrl,
}) => {
  useEffect(() => {
    document.title = title || "TB Career";

    setMetaTag("name", "description", description);
    setMetaTag("name", "keywords", keywords.join(", "));
    setMetaTag("property", "og:title", ogTitle || title);
    setMetaTag("property", "og:description", ogDescription || description);
    setMetaTag("property", "og:image", ogImage);
    setMetaTag("property", "og:image:width", "1200");
    setMetaTag("property", "og:image:height", "630");
    setMetaTag("property", "og:image:type", "image/png");
    setMetaTag("property", "og:url", ogUrl || window.location.href);
    setMetaTag("property", "og:site_name", ogSite_name);

    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", ogTitle || title);
    setMetaTag("name", "twitter:description", ogDescription || description);
    setMetaTag("name", "twitter:image", ogImage);
    setMetaTag("name", "twitter:url", ogUrl || window.location.href);
    setMetaTag("name", "twitter:site", ogSite_name);

    return () => {};
  }, [
    title,
    description,
    keywords,
    ogTitle,
    ogDescription,
    ogSite_name,
    ogImage,
    ogUrl,
  ]);

  const setMetaTag = (attr, key, content) => {
    if (!content) return;

    if (content) {
      let element = document.querySelector(`meta[${attr}="${key}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attr, key);
        document.head.appendChild(element);
      }

      element.setAttribute("content", content);
    }
  };
};

export default usePageSEO;
